import {createUseStyles} from 'react-jss';
import MediaQueries from '../../../v2/style-helper/MediaQueries';

export default createUseStyles({
  banner: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 42,
    height: '100%',
    
    [MediaQueries.phone]: {
      flexDirection: 'column',
    },
  },
});
